import styles from './Perfil.module.css'
import {useEffect, useState} from 'react'
import Input from '../form/Input'
import SelectMultiple from '../form/SelectMultiple'
import SubmitBtn from '../form/SubmitBtn'
import Container from '../layout/Container'
import {toast} from 'react-toastify'
import {__URL} from '../../config'

const SIM_NAO = [{label: 'SIM', value: 'S'}, {label: 'NÃO', value: 'N'}]
const CANAIS = [{label: 'POP-UP', value: 'POPUP'}, {label: 'E-MAIL', value: 'EMAIL'}, {label: 'AMBOS', value: 'AMBOS'}]
const DIRECIONADOS = [
    ...[1, 2, 3, 4, 5].map((p) => ({id: `prioridade_${p}_vinculado`, label: `Chamado de prioridade ${p} vinculado a mim`})),
    {id: 'replica_vinculado', label: 'Réplica em chamado vinculado a mim'},
    {id: 'finalizado_vinculado', label: 'Chamado vinculado a mim finalizado'}
]
const GERAIS = [
    ...[1, 2, 3, 4, 5].map((p) => ({id: `prioridade_${p}_aberto`, label: `Chamado de prioridade ${p} aberto no sistema`})),
    {id: 'chamado_finalizado', label: 'Qualquer chamado finalizado'}
]
const PADRAO = [...DIRECIONADOS, ...GERAIS].reduce((r, e) => ({...r, [e.id]: {ativo: 'N', canal: 'AMBOS'}}), {})

function lerPreferencias(valor) {
    if (!valor) return PADRAO
    try {
        return {...PADRAO, ...(typeof valor === 'string' ? JSON.parse(valor) : valor)}
    } catch (_) {
        return PADRAO
    }
}

function Preferencia({evento, valor, onChange}) {
    return <div className={styles.preferenceRow}>
        <span>{evento.label}</span>
        <SelectMultiple text="Receber?" name={`${evento.id}_ativo`} options={SIM_NAO} value={valor.ativo} handleOnChange={(o) => onChange(evento.id, 'ativo', o.value)} />
        <SelectMultiple text="Canal" name={`${evento.id}_canal`} options={CANAIS} value={valor.canal} disabled={valor.ativo !== 'S'} handleOnChange={(o) => onChange(evento.id, 'canal', o.value)} />
    </div>
}

function Perfil() {
    const [userSession, setUserSession] = useState(() => JSON.parse(localStorage.getItem('userSession')) || {})
    const [usuario, setUsuario] = useState(() => ({...userSession, USR_ATIVO: userSession.DT_EXCLUSAO ? 'N' : 'S'}))
    const [senha, setSenha] = useState('')
    const [confirmacao, setConfirmacao] = useState('')
    const [preferencias, setPreferencias] = useState(() => lerPreferencias(userSession.NOTIFICACOES || userSession.USR_NOTIFICACOES))
    const [salvando, setSalvando] = useState(false)

    useEffect(() => {
        if (!userSession.ID) return
        fetch(`${__URL}/usuario/${userSession.ID}`, {headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`
        }})
        .then((r) => r.ok ? r.json() : Promise.reject())
        .then((data) => {
            const dados = data.data || {}
            setUsuario((atual) => ({...atual, ...dados, USR_ATIVO: dados.DT_EXCLUSAO ? 'N' : (dados.USR_ATIVO || 'S')}))
            setPreferencias(lerPreferencias(dados.NOTIFICACOES || dados.USR_NOTIFICACOES))
        })
        .catch(() => toast.error('Não foi possível carregar todos os dados do perfil.'))
    }, [userSession.ID, userSession.TX_EMAIL, userSession.TX_HASH])

    const alterarUsuario = (campo, valor) => setUsuario((atual) => ({...atual, [campo]: valor}))
    const alterarPreferencia = (evento, campo, valor) => setPreferencias((atuais) => ({...atuais, [evento]: {...atuais[evento], [campo]: valor}}))

    function validar() {
        if (!usuario.TX_NOME?.trim()) return 'Informe o nome do usuário.'
        if ((usuario.NR_CPF || usuario.CPF || '').replace(/\D/g, '').length !== 11) return 'Informe um CPF válido com 11 dígitos.'
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(usuario.TX_EMAIL || '')) return 'Informe um e-mail válido.'
        if ((senha || confirmacao) && senha.length < 5) return 'A senha deve conter no mínimo 5 caracteres.'
        if (senha !== confirmacao) return 'A senha e a confirmação não coincidem.'
        return ''
    }

    function submit(event) {
        event.preventDefault()
        const erro = validar()
        if (erro) return toast.error(erro)

        const formData = new FormData()
        formData.append('usr_nome', usuario.TX_NOME.trim())
        formData.append('usr_cpf', (usuario.NR_CPF || usuario.CPF).replace(/\D/g, ''))
        formData.append('usr_tx_email', usuario.TX_EMAIL.trim().toLowerCase())
        formData.append('usr_ativo', usuario.USR_ATIVO)
        formData.append('usr_notificacoes', JSON.stringify(preferencias))
        if (senha) {
            formData.append('usr_tx_senha', senha)
            formData.append('usr_tx_resenha', confirmacao)
        }

        setSalvando(true)
        fetch(`${__URL}/usuario/${usuario.ID || userSession.ID}`, {
            method: 'PUT',
            headers: {'Authorization': `Basic ${window.btoa(`${userSession.TX_EMAIL}:${userSession.TX_HASH}`)}`},
            body: formData
        })
        .then((r) => r.ok ? r.json() : Promise.reject())
        .then(() => {
            const atualizada = {...userSession, TX_NOME: usuario.TX_NOME, TX_EMAIL: usuario.TX_EMAIL}
            localStorage.setItem('userSession', JSON.stringify(atualizada))
            setUserSession(atualizada)
            setSenha('')
            setConfirmacao('')
            toast.success('Perfil atualizado com sucesso!')
        })
        .catch(() => toast.error('Não foi possível atualizar o perfil.'))
        .finally(() => setSalvando(false))
    }

    const cpf = usuario.NR_CPF || usuario.CPF || ''
    return <Container customClass="middle">
        <form onSubmit={submit} className={styles.perfil}>
            <div className={styles.header}>
                <div><h1>Editar meus dados</h1><p>Atualize seus dados pessoais e preferências de notificação.</p></div>
                <SubmitBtn className={styles.perfilSubmit} text={salvando ? 'Salvando...' : 'Atualizar perfil'} hideLabel attachmentStyle />
            </div>
            <section className={styles.section}>
                <h2>Dados pessoais</h2>
                <div className={styles.personalGrid}>
                    <Input name="TX_NOME" type="text" text="Nome do usuário *" value={usuario.TX_NOME || ''} handleOnChange={(e) => alterarUsuario('TX_NOME', e.target.value.toUpperCase())} />
                    <Input name="NR_CPF" type="text" text="CPF *" placeholder="000.000.000-00" value={cpf} handleOnChange={(e) => alterarUsuario('NR_CPF', e.target.value)} />
                    <Input name="TX_EMAIL" type="email" text="E-mail *" value={usuario.TX_EMAIL || ''} handleOnChange={(e) => alterarUsuario('TX_EMAIL', e.target.value.toLowerCase())} />
                    <SelectMultiple name="USR_ATIVO" text="Cadastro ativo? *" options={SIM_NAO} value={usuario.USR_ATIVO} handleOnChange={(o) => alterarUsuario('USR_ATIVO', o.value)} />
                    <Input name="TX_SENHA" type="password" text="Nova senha" placeholder="Deixe em branco para não alterar" value={senha} handleOnChange={(e) => setSenha(e.target.value)} />
                    <Input name="TX_RESENHA" type="password" text="Confirmar nova senha" value={confirmacao} handleOnChange={(e) => setConfirmacao(e.target.value)} />
                </div>
            </section>
            <section className={styles.section}>
                <h2>Receber notificações sobre</h2>
                <div className={styles.notificationsGrid}>
                    <div><h3>Direcionados a mim</h3>{DIRECIONADOS.map((e) => <Preferencia key={e.id} evento={e} valor={preferencias[e.id]} onChange={alterarPreferencia} />)}</div>
                    <div><h3>Chamados em geral</h3>{GERAIS.map((e) => <Preferencia key={e.id} evento={e} valor={preferencias[e.id]} onChange={alterarPreferencia} />)}</div>
                </div>
            </section>
        </form>
    </Container>
}

export default Perfil
